// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-453672f4]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.svg-icon[data-v-453672f4]{margin-right:16px}.simple-mode .svg-icon[data-v-453672f4]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
